import React, { FC, useContext, useState } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Loader } from 'ncoded-component-library';
import { WithdrawButton } from '../WithdrawButton';
import CheckcircleIcon from 'icons/Checkcircle.icon';
import Nbio from '../Nbio';
import LeadContext from '../../../providers/Lead/Lead.context';

import './ProspectStepActions.styles.scss';

type ProspectStepActionsProps = {
  className?: string;
};

const ProspectStepActions: FC<ProspectStepActionsProps> = ({ className }) => {
  const [isLoading, setIsLoading] = useState(false);

  const { leadId, dealRoom } = useContext(LeadContext);

  const { t } = useTranslation();

  const classes = classNames('prospect-step-actions', className);

  return (
    <div className={classes}>
      {isLoading && <Loader />}

      <p className="title">
        <CheckcircleIcon />
        {t('interestConfirmed')}
      </p>

      <p>{t('enquiryHasBeenAccepted')}</p>

      <div className="actions">
        <Nbio />

        <WithdrawButton
          leadId={leadId}
          dealId={dealRoom?._id}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
        />
      </div>
    </div>
  );
};

export default ProspectStepActions;
